import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import WarehouseMarker from './WarehouseMarker';
var Cluster = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 25px;\n  color: ", ";\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 800;\n  height: ", "px;\n  left:15px;\n  line-height: ", "px;\n  position: absolute;\n  text-align: center;\n  top:-14px;\n  transform: translate(-50%, -50%);\n  vertical-align: middle;\n  width: ", "px;\n  z-index: 5;\n"])), function (props) {
  return props.theme.colors.dark;
}, function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.radius;
});

var WarehouseClusterMarker = function WarehouseClusterMarker(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function (e) {
    return e;
  } : _ref$onClick,
      _ref$points = _ref.points,
      points = _ref$points === void 0 ? [] : _ref$points,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 27 : _ref$radius;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Cluster, {
    onClick: function onClick() {
      return _onClick(points);
    },
    radius: radius,
    type: "button"
  }, count), /*#__PURE__*/React.createElement(WarehouseMarker, {
    isActive: true,
    onClick: function onClick() {
      return _onClick(points);
    }
  }));
};

export default WarehouseClusterMarker;